import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { switchMap, catchError } from 'rxjs/operators';

import { UManagerSlugService } from '../services/umanager-slug.service';
import { UtmStorageService } from '../services/utm-storage.service';

@Injectable({
  providedIn: 'root',
})
export class SlugRedirectGuard implements CanActivate {
  private umanagerSlugService = inject(UManagerSlugService);
  private utmStorageService = inject(UtmStorageService);
  private router = inject(Router);


  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const slug = route.paramMap.get('slug');
    
    if (!slug) {
      this.router.navigate(['/404']);
      return of(false);
    }

    const queryParams = route.queryParams;
    const utmParams: Record<string, string> = {};
    
    Object.keys(queryParams).forEach(key => {
      if (key.toLowerCase().startsWith('utm_')) {
        utmParams[key.toLowerCase()] = queryParams[key];
      }
    });

    return this.umanagerSlugService.resolveSlug(slug).pipe(
      switchMap(response => {
        if (!response || !response.default_destination) {
          this.router.navigate(['/404']);
          return of(false);
        }

        this.utmStorageService.persistTrackingData(
          response.channel_id,
          utmParams
        );

        if (response.default_destination.startsWith('http://') || 
            response.default_destination.startsWith('https://')) {
          window.location.href = response.default_destination;
          return of(false);
        } else {
          this.router.navigateByUrl(response.default_destination);
          return of(false);
        }
      }),
      catchError(error => {
        console.error('Erro ao processar slug redirect:', error);
        this.router.navigate(['/404']);
        return of(false);
      })
    );
  }
}

